import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SurveyDetailDto, SurveyDto, SurveyGroupDto } from './types/survey-dto';
import { catchError } from 'rxjs/operators';
import { OeAppService } from './oe-app.service';
import { OeAppPersonService } from './oe-app-person.service';
import { SurveyId } from './types/survey-id.enum';
import { SelectedSurveyQuestionOptions } from 'app/teacher-feedback/teacher-feedback-service/selected-survey-question-options';

@Injectable({
  providedIn: 'root',
})
export class LiveClassSurveyService {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  getSurveyDetails(liveSessionId: number): Observable<SurveyDetailDto> {
    return this.http
      .get<SurveyDetailDto>(
        `${this.oeAppService.oeLiveClassServiceHost}/v1/surveys/details/${this.oeAppPersonService.id}/${liveSessionId}`
      )
      .pipe(catchError(() => of(null)));
  }

  getSurveyQuestions(surveyId: SurveyId): Observable<SurveyGroupDto[]> {
    return this.http
      .get<SurveyDto>(
        `${this.oeAppService.oeLiveClassServiceHost}/v1/surveys/questions/${this.oeAppPersonService.id}/${surveyId}`
      )
      .pipe(catchError(() => of(null)));
  }

  saveSurvey(
    answers: { profileQuestionId: number; profileQuestionOptionId: number }[],
    liveSessionId: number
  ): Observable<any> {
    return this.http.post(`${this.oeAppService.oeLiveClassServiceHost}/v1/surveys/answers/${this.oeAppPersonService.id}/${liveSessionId}`, answers).pipe(catchError(() => of(null)));
  }

  saveTeacherFeedbackSurvey(answers: SelectedSurveyQuestionOptions[], feedbackResponseId: number) {
    return this.http.post(`${this.oeAppService.oeLiveClassServiceHost}/v1/surveys/teacherFeedback/answers/${this.oeAppPersonService.id}/${feedbackResponseId}`, answers);
  }

  getTeacherFeedbackSurvey(feedbackResponseId: number) {
    return this.http.get<SelectedSurveyQuestionOptions[]>(`${this.oeAppService.oeLiveClassServiceHost}/v1/surveys/teacherFeedback/answers/${this.oeAppPersonService.id}/${feedbackResponseId}`);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/live-class-survey.service.ts